const RANKING = [
  { rank: 1, title: '流浪地球3', tag: '科幻巨制', hot: '9.8', desc: '太阳急速老化，人类面临前所未有的生存危机，新一代航天员再次踏上拯救地球的壮烈征程。' },
  { rank: 2, title: '封神第二部', tag: '神话史诗', hot: '9.6', desc: '殷商末年，封神大战持续升级，姬发率领西岐大军与殷商精锐展开终极对决。' },
  { rank: 3, title: '速度与激情11', tag: '动作大片', hot: '9.5', desc: '多米尼克家族面临史上最危险的敌人，全球飙车追逐引爆肾上腺素。' },
  { rank: 4, title: '哪吒之魔童闹海', tag: '国漫之光', hot: '9.4', desc: '天劫之后哪吒与敖丙灵魂尚存，太乙真人以莲藕重塑肉身，新的冒险就此展开。' },
  { rank: 5, title: '奥本海默', tag: '历史传记', hot: '9.3', desc: '聚焦"原子弹之父"罗伯特·奥本海默的传奇一生，科学与道德的终极碰撞。' },
];

const CAROUSEL_ITEMS = [
  {
    title: '暑期档大片合集',
    desc: '2026年暑期档最强片单，动作、科幻、喜剧一网打尽，陪你度过炎炎夏日。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20action%20and%20sci-fi%20elements%2C%20warm%20golden%20sunset%20tones%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20movie%20poster%20style%20composition%2C%20no%20text%20no%20letters&width=640&height=400&seq=carousel-summer-01&orientation=landscape',
  },
  {
    title: '经典高分影片回顾',
    desc: 'IMDb与豆瓣双料高分经典，每一部都值得反复品味，电影爱好者的必修课。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20old%20Hollywood%20glamour%2C%20warm%20sepia%20and%20gold%20tones%2C%20film%20noir%20atmosphere%2C%20elegant%20cinematic%20composition%2C%20soft%20spotlight%2C%20no%20text%20no%20letters&width=640&height=400&seq=carousel-classic-02&orientation=landscape',
  },
  {
    title: '国漫崛起专题',
    desc: '从大圣归来到哪吒，国产动画电影正在创造奇迹，见证国漫的辉煌时代。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20artistic%20style%20with%20ink%20wash%20painting%20aesthetic%2C%20ethereal%20dreamlike%20atmosphere%2C%20traditional%20Chinese%20elements%20blended%20with%20modern%20cinematic%20look%2C%20soft%20warm%20lighting%2C%20no%20text%20no%20letters&width=640&height=400&seq=carousel-anime-03&orientation=landscape',
  },
  {
    title: '奥斯卡获奖影片',
    desc: '历届奥斯卡最佳影片、最佳导演获奖作品全收录，殿堂级电影艺术鉴赏。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Prestigious%20film%20awards%20atmosphere%20with%20golden%20statue%20silhouette%2C%20elegant%20red%20carpet%20aesthetic%2C%20Hollywood%20glamour%2C%20dramatic%20spotlighting%2C%20luxurious%20dark%20background%20with%20gold%20accents%2C%20no%20text%20no%20letters&width=640&height=400&seq=carousel-oscar-04&orientation=landscape',
  },
];

const CARDS = [
  {
    title: '沙丘：第三部',
    category: '科幻冒险',
    desc: '保罗·厄崔迪斯掌控帝国命运，沙丘星球的终极秘密即将揭晓，史诗科幻系列迎来震撼终章。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20desert%20planet%20landscape%20with%20giant%20sandworms%2C%20mystical%20golden%20atmosphere%2C%20cinematic%20sci-fi%20aesthetic%2C%20dramatic%20warm%20lighting%2C%20vast%20scale%20composition%2C%20no%20text%20no%20people&width=500&height=700&seq=card-dune-01&orientation=portrait',
  },
  {
    title: '孤注一掷2',
    category: '犯罪剧情',
    desc: '网络诈骗集团死灰复燃，跨国追捕再次升级，根据多起真实案件改编的震撼续作。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tense%20dramatic%20urban%20night%20scene%20with%20neon%20lights%2C%20suspense%20thriller%20atmosphere%2C%20dark%20alleys%20with%20contrasting%20warm%20glow%2C%20cinematic%20composition%2C%20no%20text%20no%20people&width=500&height=700&seq=card-crime-02&orientation=portrait',
  },
  {
    title: '功夫熊猫5',
    category: '动画喜剧',
    desc: '阿宝再次回归！这一次熊猫大侠要面对来自神秘东方的新挑战，笑料与热血并存。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20style%20Chinese%20landscape%20with%20cherry%20blossoms%20and%20ancient%20temples%2C%20vibrant%20warm%20colors%2C%20playful%20cinematic%20atmosphere%2C%20dreamlike%20quality%2C%20no%20text%20no%20characters&width=500&height=700&seq=card-kungfu-03&orientation=portrait',
  },
  {
    title: '碟中谍9',
    category: '动作谍战',
    desc: '伊森·亨特面对AI失控危机，全球取景实拍特技再次突破极限，年度最燃谍战大片。',
    imageUrl: 'https://readdy.ai/api/search-image?query=High-tech%20spy%20action%20aesthetic%20with%20futuristic%20cityscape%2C%20dramatic%20golden%20hour%20lighting%2C%20sleek%20modern%20architecture%2C%20intense%20cinematic%20atmosphere%2C%20cool%20and%20warm%20contrast%2C%20no%20text%20no%20people&width=500&height=700&seq=card-mission-04&orientation=portrait',
  },
  {
    title: '长安三万里2',
    category: '历史动画',
    desc: '续写大唐诗人传奇，李白与高适的人生轨迹再次交织，以动画呈现盛唐诗歌之美。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Chinese%20cityscape%20with%20traditional%20architecture%2C%20poetic%20atmosphere%2C%20warm%20golden%20lantern%20light%2C%20ink%20painting%20aesthetic%20blended%20with%20animation%20style%2C%20no%20text%20no%20people&width=500&height=700&seq=card-changan-05&orientation=portrait',
  },
];

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-16 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          影视榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          本周热门影片实时排行
        </p>
        <div className="space-y-3">
          {RANKING.map((item, i) => (
            <div key={i} className="flex items-center gap-4 bg-background-50 rounded-lg p-4 border border-background-200 hover:border-accent-200 transition-colors cursor-pointer">
              <div className={'w-9 h-9 rounded-lg flex items-center justify-center font-heading font-bold text-lg flex-shrink-0 ' + (
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-secondary-400 text-white' :
                item.rank === 3 ? 'bg-primary-400 text-white' :
                'bg-background-200 text-foreground-500'
              )}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-sm text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
                <i className="ri-fire-line text-sm"></i>
                <span className="font-heading font-bold text-lg">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-16 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          热门专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          精心策划的电影主题合集
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CAROUSEL_ITEMS.map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative h-44 sm:h-48 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-16 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mt-2 mb-10">
          编辑团队每日甄选优质影片
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {CARDS.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer flex flex-col">
              <div className="relative h-52 sm:h-56 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="text-xs px-2 py-1 rounded-full bg-accent-500 text-white font-medium whitespace-nowrap">{item.category}</span>
                </div>
              </div>
              <div className="p-3.5 flex-1 flex flex-col">
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}